import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/quote-left.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/quote-right.svg';
import { mapGetters } from 'vuex';
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'HomeBlog',
  components: {
    GlobalTitle: GlobalTitle,
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    article: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentPayload: function currentPayload() {
      var _ref3;

      return {
        title: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? (_ref3 = _ref3.title) != null ? _ref3[0] : _ref3 : _ref3 : _ref3) || {},
        url: "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/article/").concat(this.payload.primary.article.slug)
      };
    },
    currentArticle: function currentArticle() {
      var _ref, _ref2;

      return {
        title: ((_ref2 = this.article[0]) != null ? (_ref2 = _ref2.data) != null ? (_ref2 = _ref2.main_title) != null ? (_ref2 = _ref2[0]) != null ? _ref2.text : _ref2 : _ref2 : _ref2 : _ref2) || '',
        description: ((_ref = this.article[0]) != null ? (_ref = _ref.data) != null ? _ref.description : _ref : _ref) || '',
        image: "".concat(formatPrismicImage(this.article[0].data.image.large.url, ['w_375']), " 375w, ").concat(formatPrismicImage(this.article[0].data.image.large.url, ['w_375', 'dpr_2']), " 750w, ").concat(formatPrismicImage(this.article[0].data.image.large.url, ['w_1440']), " 1440w"),
        button: {
          text: this.payload.primary.button_text || ''
        },
        tracking: {
          data: {
            event_category: this.payload.primary.event_category || '',
            event_action: this.payload.primary.event_action || '',
            event_label: this.payload.primary.event_label || ''
          }
        }
      };
    }
  })
};